export default __webpack_public_path__ + "static/media/Snd_g1.177ba920.mp3";